import * as angular from "angular";
import {IController} from "angular";

export class AccountTypeSelectCtrl implements IController {

  types: string[];
  type: any;

  typeChanged: Function;

  constructor() {
  }

  $onInit() {
  };

  select(type) {
    this.type = type;
    this.typeChanged({type: type});
  }

  clear() {
    this.select(undefined);
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('accountTypeSelect', {
    bindings: {
      types: '<',
      type: '<',
      typeChanged: '&'
    },
    template: require('./account-type-select.html').default,
    controller: AccountTypeSelectCtrl
  });
